import React, { useEffect, useState, useCallback } from 'react';
import { Typography } from '@mui/material';
import DashboardLayout from './DashboardLayout';
import AddCampaignCard from './Campaigns/Addcampaign';
import CampaignAccountability from './Campaigns/Accountability';
import CampaignManager from './Campaigns/CampaignManager';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PageLoader from '../../../Reusable/PageLoader';
import baseURL from '../config';

const Dashboard = () => {
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchCampaigns = useCallback(async () => {
        setLoading(true);
        try {
            // await new Promise(resolve => setTimeout(resolve, 4000));

            const response = await fetch(`${baseURL}/user/campaigns`, {
                method: "GET",
                credentials: "include",
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Failed to fetch campaigns.");
            }

            setCampaigns(data || []);
        } catch (err) {
            console.error("Error fetching campaigns:", err);
            toast.error(err.message || "Failed to load campaigns.");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchCampaigns();
    }, [fetchCampaigns]);

    return (
        <DashboardLayout>
            {loading && <PageLoader />} {/* Loader inside layout */}

            {!loading && (
                <>
                    <Typography
                        variant="h6"
                        sx={{
                            color: '#666',
                            marginBottom: 2,
                            textAlign: 'left',
                            mt: { xs: 10, sm: 3 },
                            fontWeight: '600',
                        }}
                    >
                        Create a campaign
                    </Typography>
                    <AddCampaignCard onCampaignCreated={fetchCampaigns} />

                    <Typography
                        variant="h6"
                        sx={{
                            color: '#666',
                            marginBottom: 2,
                            textAlign: 'left',
                            marginTop: 2,
                            fontWeight: '600',
                        }}
                    >
                        Campaigns
                    </Typography>
                    <CampaignManager campaigns={campaigns} onCampaignUpdated={fetchCampaigns} />

                    <Typography
                        variant="h6"
                        sx={{
                            color: '#666',
                            marginBottom: 2,
                            textAlign: 'left',
                            marginTop: 2,
                            fontWeight: '600',
                        }}
                    >
                        Account for campaigns
                    </Typography>
                    <CampaignAccountability campaigns={campaigns} onAccountabilitySubmitted={fetchCampaigns} />
                </>
            )}
        </DashboardLayout>
    );
};

export default Dashboard;
